export default {
    namespaced: true,
    state: {
        data: {}
    },
    mutations: {
        SET_CONFIG_DATA: (state, payload) => state.data = payload,
    },
    actions: {
        getConfigData: ({state, commit}) => {
            return axios({url: '/info/mail-settings', method: 'GET' })
                .then(resp => {
                    commit('SET_CONFIG_DATA', resp.data)
                })
                .catch(err => {
                    console.log('Произошла ошибка при загрузке данных.')
                    console.log(err)
                })
        },
        updateConfigData: ({state, commit}, data) => {
            return axios({url: '/info/mail-settings', data: data, method: 'POST' })
                .then(resp => {
                    // commit('SET_CONFIG_DATA', resp.data)
                    console.log(resp.data.message)
                })
                .catch(err => {
                    console.log('Произошла ошибка при загрузке данных.')
                    console.log(err)
                })
        }
    },
    getters: {
        CONFIG_DATA: state => state.data,
    }
}
